import Vue from 'vue';
import Endpoints from "@/share/Endpoints";

export const getEvents = async ( {commit}, organizationId ) => {
  try {
    let events = await Vue.axios({
      method: 'GET',
      url: Endpoints.memberEvents+`/${organizationId}`
    });
    commit('setEvents', events);
    return {status: true, events: events};
  } catch (error) {
    return {status: false, message: error}
  }
}

export const getEventsById = async ( {commit}, orgId ) => {
  try {
    let event = await Vue.axios({
      method: 'GET',
      url: Endpoints.memberEvents+'/'+orgId
    });
    commit('setEvents', events);
    return {status: true, events: events};
  }
  catch (error) {
    return {status: false, message: error}
  }
}

export const fetchMyPurchasedEvents = async ({ commit }) => {
  try {
    const response = await Vue.axios({
      method: 'GET',
      url: Endpoints.memberPurchasedEvents,
    });
    const items = response.data.items || [];
    commit('setPurchasedEvents', items);
    return { status: true, items };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const fetchZoomJoinLink = async (_ctx, eventId) => {
  try {
    const response = await Vue.axios({
      method: 'POST',
      url: Endpoints.zoomJoinLink.replace(':eventId', eventId),
    });
    return { status: true, joinUrl: response.data.joinUrl, cached: response.data.cached };
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || 'Error al obtener el enlace de Zoom';
    return { status: false, message };
  }
};